/**
 * @file locations.api.js
 * @module LocationsAPI
 * @description HTTP API wrapper for location-related endpoints.
 * Exports `LocationsAPI` object with methods that return an Axios Promise.
 *
 * Common usage:
 * LocationsAPI.getPlaceDetailsByPlaceId(placeId)
 *   .then(response => ...)
 *
 * All methods use axiosInstance() and return the promise produced by axios.
 */

import { axiosInstance } from "./axios";

export const LocationsAPI = {
    /**
     * Get place details using a place id.
     * @param {string} placeId - Place identifier.
     * @returns {Promise} Axios promise resolving to place details.
     */
    getPlaceDetailsByPlaceId: (placeId) => {
        return axiosInstance().get(`/places-details/${placeId}`);
    }
}